export { Edit3 as default } from './Edit3';
